import React from 'react';
import { styled } from '@mui/material/styles';
import { Modal } from '~/shared/components';

const ModalText = styled('div')`
  width: 100%;
  color: var(--color-gray-1) !important;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 2px;
`;

const ModalTextMargin = styled(ModalText)`
  margin-bottom: 12px;
`;

const ModalBody = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 24px;
  width: 100%;
  height: 100%;
`;

type UserExpiredModalProps = {
  onClose: () => void;
};

const UserExpiredModal = ({ onClose }: UserExpiredModalProps) => {
  return (
    <Modal
      open
      title="Your trial has ended"
      showCancelButton={false}
      onClose={onClose}
      onConfirm={onClose}
      confirmText="Close"
      width={630}
      content={
        <ModalBody>
          <ModalTextMargin>Dear MediaStats Narratives platform user,</ModalTextMargin>

          <ModalTextMargin>
            We are no longer able to provide you with access to the platform. We appreciate your interest and feedback.
            Please reach out at <a href="mailto:info@mktmediastats.com">info@mktmediastats.com</a> if you have any
            questions or concerns.
          </ModalTextMargin>

          <ModalText>All the best,</ModalText>
          <ModalText>The MKT MediaStats team</ModalText>
        </ModalBody>
      }
    />
  );
};

export default UserExpiredModal;
